module.exports = __webpack_public_path__ + "img/splash.afbd2848.png";